import styled from "@emotion/styled";
import { Container } from "@mui/material";
import React from "react";

const Img2 = styled.div``;
const Img = styled.div``;

const Img1 = styled.img`
  width: 100%;
  height: 400px;
  @media (max-width: 399px) {
    height: 300px;
  }
`;

const SliderMain = styled.div`
  border: 1px solid black;
  max-width: 89%;
  text-align: center;
  @media (max-width: 599px) {
    max-width: 100%;
  }
`;
const SliderText = styled.div`
  text-align: left;
  min-height: 260px;
  padding: 35px 20px 50px 20px;
  @media (max-width: 1115px) {
    padding: 25px 20px 20px 20px;
    min-height: 280px;
  }
`;
const HeadingIn = styled.h3`
  font-weight: 900;
  padding-bottom: 10px;
  font-size: 35px;
  @media (max-width: 1115px) {
    font-size: 30px;
  }
  @media (max-width: 960px) {
    font-size: 28px;
  }
`;
const Text = styled.div`
  padding-top: 30px;
  font-size: 16px;
  line-height: 20px;
  @media (max-width: 1115px) {
    padding-top: 10px;
  }
`;
const index = (props) => {
  return (
    <div>
      {/* <Container> */}
      <SliderMain>
        <SliderText>
          <HeadingIn>{props.heading}</HeadingIn>
          <Text>{props.text}</Text>
        </SliderText>
        <div>
          <Img1 className="img-fluid" src={props.CardImg} alt="Images" />
        </div>
      </SliderMain>
      {/* </Container> */}
    </div>
  );
};

export default index;
